import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "components__rec-additional-info" }

import { recProps } from '../../mixins/rec-component';
  
  import InfoItem from "vue/applications/frontend/components/info-item.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-additional-info',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.info_items, (infoItem) => {
        return (_openBlock(), _createElementBlock("li", {
          key: infoItem.id
        }, [
          _createVNode(InfoItem, { "info-item": infoItem }, null, 8, ["info-item"])
        ]))
      }), 128))
    ])
  ]))
}
}

})